import { render, staticRenderFns } from "./DocumentCorrections.vue?vue&type=template&id=1258c3e2&scoped=true&"
import script from "./DocumentCorrections.vue?vue&type=script&lang=js&"
export * from "./DocumentCorrections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1258c3e2",
  null
  
)

export default component.exports